import ru from './ru.json';

const locales = {
  ru,
};

export default locales;
